import { useState, useEffect } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

const StaticGrid = () => {
    const [actualites, setActualites] = useState([]);

    useEffect(() => {
        const fetchActualites = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/actualite?populate=*`, {
                    headers: {
                        Authorization: `${process.env.REACT_APP_API_TOKEN}`
                    }
                });
                // Prendre les 6 dernières actualités
                setActualites(response.data.data.slice(0, 3));
            } catch (error) {
                console.error('Error fetching actualites:', error);
            }
        };

        fetchActualites();
    }, []);

    return (
        <section className="relative bg-cream p-4 mx-12 my-28 ">
            <div className="grid grid-cols-3 grid-rows-1 gap-4">
                {actualites.map((actualite) => (
                    <Card key={actualite.id} actualite={actualite} />
                ))}
            </div>
        </section>
    );
};

const Card = ({ actualite }) => {
    return (
        <motion.div
            whileHover={{ y: -10 }}
            transition={{ duration: 0.3 }}
            key={actualite.id}
            className="w-full h-[400px] relative border-0 md:border-4 border-black rounded-3xl overflow-hidden" 
        >
            <Link to={`/actualites/${actualite.documentId}`}>
                <div
                    style={{
                        backgroundImage: `url(${actualite.imageCouverture.url})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                    }}
                    className="absolute inset-0 z-10 rounded-2xl"
                ></div>
                <div className="absolute inset-0 z-10 grid place-content-start">
                    <p className="bg-gradient-to-br from-/20 to-/0 p-8 text-4xl font-cormorant font-bold uppercase text-white ">
                        {actualite.titre}
                    </p>
                </div>
                <div className="absolute inset-0 z-10 grid place-content-end">
                    <p className="p-8 text-4xl font-cormorant uppercase ">
                        <a href={`/actualites/${actualite.documentId}`} className="text-white">Read More</a>
                    </p>
                </div>
            </Link>
        </motion.div>
    );
};

export default StaticGrid;

const cards = [
    {
        url: "https://i.pinimg.com/736x/9b/86/6c/9b866c6be509cbe55bf363f0152067b5.jpg",
        title: "Title 1",
        id: 1,
    },
    {
        url: "https://i.pinimg.com/736x/7d/26/e8/7d26e8d0d1c8e260c1016ea858dcf99e.jpg",
        title: "Title 2",
        id: 2,
    },
    {
        url: "https://i.pinimg.com/736x/3a/37/28/3a3728f77478147526e8a20a5280ba43.jpg",
        title: "Title 3",
        id: 3,
    },
    {
        url: "https://i.pinimg.com/736x/8e/49/57/8e4957bc6162a84fdd014726e0d7512e.jpg",
        title: "Title 4",
        id: 4,
    },
    {
        url: "https://i.pinimg.com/736x/58/f9/12/58f912eeec6682fe8e7279f32895fe93.jpg",
        title: "Title 5",
        id: 5,
    },
    {
        url: "https://i.pinimg.com/736x/e8/6f/c5/e86fc5ed0007b729710b59ddb6f727b6.jpg",
        title: "Title 6",
        id: 6,
    },
];